import SelectFilter from "@components/common/SelectFilter.jsx";
import useFilterData from "@hooks/useFilterData.js";

function RolesFilter({ value, onChange, params = {}, enabled = true }) {
	const { data, isLoading, hasMore, searchTerm, loadMore, setSearchTerm } = useFilterData({
		endpoint: "/api/roles",
		enabled,
		queryParams: {
			...params,
		},
	});
	return (
		<SelectFilter
			id="roles-filter"
			dataTestId="roles-filter"
			label="Filter by"
			placeholder="Roles"
			value={value}
			onChange={onChange}
			options={data}
			isLoading={isLoading}
			hasMore={hasMore}
			onLoadMore={loadMore}
			searchTerm={searchTerm}
			onSearchChange={setSearchTerm}
			optionLabel="name"
			optionValue="id"
			showSearch={true}
			searchPlaceholder="Search by role"
		/>
	);
}

export default RolesFilter;
